import { I18n } from '@calendly/i18n'

import { useInScope } from 'hooks/meetings/use_in_scope'

import { DropdownFilter } from './dropdown/dropdown_filter'
import { FilterLayout } from './filter_layout'

export const UsersSelect = ({ params, onApply, useColumnLayout = false }) => {
  const inScope = useInScope('user')

  if (!inScope) return null

  const controlText = params.user_ids.length === 0
    ? I18n.t('publisher.dashboard.filters.label.user_all')
    : I18n.t('publisher.dashboard.filters.label.user', { count: params.user_ids.length })

  const applySelectedIds = (values) => {
    onApply({
      ...params,
      user_ids: values?.user_0 || []
    })
  }

  return (
    <FilterLayout
      label={I18n.t('publisher.labels.user')}
      useColumnLayout={useColumnLayout}
    >
      <DropdownFilter
        name="user"
        params={params}
        showHeader
        showSearchInput
        onApply={applySelectedIds}
        controlText={controlText}
      />
    </FilterLayout>
  )
}
